import type { SignalId } from "@repo/app-types/entities/signal";
import { SimpleMenu } from "@repo/ui/Menu/simpleMenu";
import { SimpleMenuItem } from "@repo/ui/Menu/simpleMenuItem";
import { SimpleMenuPopover } from "@repo/ui/Menu/simpleMenuPopover";
import type { FC } from "react";
import { SubmenuTrigger } from "react-aria-components";
import { useAllSignalsQuery } from "../../api/entities/signal.js";

export interface SignalFilterOptionProps {
  value: SignalId | null;
  onChange: (newValue: SignalId | null) => void;
}

export const SignalFilterOption: FC<SignalFilterOptionProps> = ({
  value,
  onChange,
}) => {
  // A never-published signal has no matches to filter by.
  const signals = useAllSignalsQuery().data?.filter(
    (signal) => signal.live_version_id !== null,
  );

  if (value !== null || !signals || signals.length === 0) {
    return null;
  }

  return (
    <SubmenuTrigger>
      <SimpleMenuItem>Signal</SimpleMenuItem>

      <SimpleMenuPopover>
        <SimpleMenu aria-label="Filter by signal">
          {signals.map((signal) => (
            <SimpleMenuItem
              key={signal.id}
              onAction={() => onChange(signal.id)}
            >
              {signal.name}
            </SimpleMenuItem>
          ))}
        </SimpleMenu>
      </SimpleMenuPopover>
    </SubmenuTrigger>
  );
};
